module.exports = __webpack_public_path__ + "static/img/default-banner.85fc4a4.png";